import React from 'react';
import { bonos, bonosTotalValue } from '../data/bonos';
import { Emoji } from './Emoji';
export function Bonos() {
  return <section className="w-full bg-forest-800 py-20" style={{
    paddingTop: "17px"
  }} data-id="element-16" data-mp="2hdcya1siix0d">
      <div className="mx-auto max-w-content px-5 text-center sm:px-8" data-id="element-17" data-mp="2ld3uwm4q07ct">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-3 font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-cream sm:text-4xl" data-id="element-18" data-mp="2q4myud1ybtek">
          <Emoji symbol="🎁" className="text-4xl" data-id="element-19" data-mp="2v6c7xn5m5x00" />
          6 Bonos Estratégicos
        </h2>
        <p className="mt-3 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-lime-400" data-id="element-20" data-mp="304vxrynbvsxn">
          Siempre incluidos
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-cream/70" data-id="element-21" data-mp="392ps541j8ci6">
          Porque el sistema no termina en las recetas.
        </p>

        <ul className="mt-12 grid gap-5 text-left md:grid-cols-2 lg:grid-cols-3" data-id="element-22" data-mp="1aqhaliryke49">
          {bonos.map(bono => <li key={bono.index} className="h-full" data-id="element-23" data-mp="3e40ya4nq4yra">
              <article className="flex h-full flex-col rounded-2xl border-2 border-lime-500 bg-forest-950 p-6 shadow-[0_0_20px_-6px_rgba(34,197,94,0.5)]" style={{
            paddingTop: "10px"
          }} data-id="element-24" data-mp="3e4sunhp5b0im">
                <p className="font-display text-3xl font-black leading-none text-lime-400" data-id="element-25" data-mp="34eprwps82873">
                  {bono.index}
                </p>
                <p className="mt-3 inline-flex items-center gap-2 font-display text-[11px] font-extrabold uppercase tracking-[0.16em] text-lime-500" data-id="element-26" data-mp="xhau85bjcdf">
                  <Emoji symbol="🎁" data-id="element-27" data-mp="3s53kchepy927" />
                  Bono {Number(bono.index)}
                </p>
                <h3 className="mt-3 inline-flex items-center gap-2 font-display text-base font-extrabold uppercase leading-snug tracking-tight text-cream" data-id="element-28" data-mp="3n34i5aupti6u">
                  <Emoji symbol={bono.emoji} data-id="element-29" data-mp="2bpaexugzy58j" />
                  {bono.title}
                </h3>
                <p className="mt-3 text-[14px] leading-relaxed text-cream/70" data-id="element-30" data-mp="26qpje8cow9qf">
                  {bono.description}
                </p>
                <p className="mt-auto flex items-center gap-3 pt-6" data-id="element-31" data-mp="ysbkoxky12eg">
                  <span className="text-sm text-cream/45 line-through" data-id="element-32" data-mp="12t3vvwddlhdd">
                    {bono.value}
                  </span>
                  <span className="rounded-full bg-lime-500 px-3 py-1 font-display text-xs font-extrabold uppercase tracking-wide text-forest-950" data-id="element-33" data-mp="os189f6qfz0c">
                    Gratis
                  </span>
                </p>
              </article>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border-2 border-gold/40 bg-forest-900 px-7 py-7" data-id="element-34" data-mp="ju9dmdepdysg">
          <p className="font-display text-lg font-bold text-cream" data-id="element-35" data-mp="63e4d00alfoc">
            Valor total de los 6 bonos
          </p>
          <p className="mt-2 font-display text-3xl text-cream/50 line-through" data-id="element-36" data-mp="b1xr32mpmvhr">
            {bonosTotalValue}
          </p>
          <p className="mt-2 font-display text-xl font-extrabold text-gold" data-id="element-37" data-mp="3sbmd4qm2rzez">
            → Gratis con tu Mega Pack
          </p>
        </div>
      </div>
    </section>;
}